<script setup>
/**
 * @import { Ref } from 'vue'
 */
import { ref } from 'vue'
import { postRequest } from '@/utils/fetch'

defineProps({
  isDisplay: {
    type: Boolean,
    required: true,
  },
  close: {
    type: Function,
    required: true,
  },
})

const isDisableExam =
  /** @type {HTMLInputElement} */ (document.getElementById('_h_is_disable_exam_by_term'))?.value ?? ''

const taExamExecUrl = /** @type {HTMLInputElement} */ (document.getElementById('_h_ta_exam_exec_url'))?.value ?? ''
/**
 *
 */
const transitionTa = async () => {
  const data = await postRequest('student_api_ta_tainfo_updateexec', taExamExecUrl, {}, { withCsrf: true })
  if (data.data?.url.length) {
    location.href = data.data.url
  } else {
    isShowTaError.value = true
  }
}

/** @type {Ref<boolean>} */
const isShowTaError = ref(false)
</script>

<template>
  <Teleport to="#modals">
    <div
      class="md_modal md_modal--small modal_TAerror"
      v-if="isShowTaError"
    >
      <button
        class="bgLayer js_modalX"
        @click="isShowTaError = false"
      ></button>
      <div class="modalSet">
        <div class="Content">
          <div class="titleArea">
            <div class="title">
              通信に失敗しました
              <span
                class="closeLink js_modalX"
                @click="isShowTaError = false"
              ></span>
            </div>
            <div class="copy">時間をおいて再度お試しください。</div>
          </div>
          <div class="actionArea">
            <div class="btnSet">
              <button
                class="md_btn md_btn--line js_modalX"
                @click="isShowTaError = false"
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
  <div
    class="md_modal modal_TA"
    v-show="isDisplay && !isShowTaError"
  >
    <button
      class="bgLayer"
      @click="close"
    ></button>
    <div class="modalSet">
      <div class="Content">
        <div class="titleArea">
          <div class="title">
            性格・価値観分析の受検画面に<br class="pcHide" />移動しますか？<span
              class="closeLink js_modalX"
              @click="close"
            ></span>
          </div>
          <div class="copy">診断結果はスカウト企業も閲覧できます。集中できる環境で取り組みましょう。</div>
        </div>
        <div class="actionArea">
          <div class="btnSet">
            <button
              class="md_btn md_btn--sub"
              @click="close"
            >
              キャンセル
            </button>
            <a
              @click="transitionTa()"
              class="md_btn md_btn--submit"
              :class="{ 'md_btn--disable': isDisableExam == '1' }"
              rel="noopener noreferrer"
              >受検サイトへ</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
